<template>
	<div style="margin-bottom: 6px;">
		<el-row :gutter="20">
			<el-col :span="4">
				<div>
					<el-statistic group-separator="," :precision="0" :value="remain" title="延迟导入(剩余数据)"></el-statistic>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<el-statistic group-separator="," :precision="0" :value="total" title="总SKU数"></el-statistic>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<el-statistic group-separator="," :precision="4" :value="progress" title="关联完成度(%)"></el-statistic>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<style>

</style>

<script>
	export default {
		name: '',
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				remain: 0,
				total:0,
				progress:0,
			}
		},
		watch: {

		},
		mounted() {
			this.static()
		},
		computed: {
			currentMonth() {
				let currentDate = new Date()
				currentDate.setDate(1)
				return currentDate.getTime()
			}
		},

		methods: {
			static() {
				this.$api.goodsonline.static().then((res) => {
					this.remain = res.remain
					this.total = res.total
					this.progress = parseFloat(res.progress)
					
				})
			},
			change(e) {
				this.static(e)

			},
			// checkRefund() {
			// 	let proxyInfo = this.list.getGrid().getProxyInfo()
			// 	proxyInfo.form.refund_no = '不为空'
			// 	console.log(proxyInfo)
			// 	this.list.getGrid().commitProxy('query')
			// }
		},
		components: {

		}
	}
</script>
